export default __webpack_public_path__ + "static/23-fb1e244ab3d194d05179dd2d0defd3bd.png";